/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Shipping_FeeInputs */

const vi_carrier_shipping_fee = /** @type {(inputs: Carrier_Shipping_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cước vận chuyển`)
};

/**

* @param {Carrier_Shipping_FeeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_shipping_fee = /** @type {((inputs?: Carrier_Shipping_FeeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Shipping_FeeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_shipping_fee(inputs)
});